import React, { useState, useMemo, useEffect } from 'react';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { IState } from 'services/root-reducer';
import {
    Panel, CloseButton
} from 'components';
import { routes } from 'routes';

import {
    getContainerFilters
} from 'selectors';

import { actions as appActions } from 'services/app/app-service';
import { actions as containersActions } from 'services/containers/containers-service';
import { isTablet } from 'react-device-detect';
import i18next from 'i18next';
import { ListFilters } from './filters';
import { ObjectsList } from './objects-list';
import './style.scss';


export interface IListWindowProps {
    layerCode: string
}

const ListWindowComponent: React.FC<IListWindowProps> = (props): JSX.Element => {
    const { layerCode } = props;

    useEffect(() => {
        if (i18next.language !== 'ru'
            && [ 'folder88', 'folder12', 'productive_agricultural_land' ].includes(layerCode)) {
            routes.goBack(routes.map, { container: 'root' }, routes.currRouteState);
            containersActions.setContainerSelected({ id_or_code: 'folder88', selected: false });
            containersActions.setContainerSelected({ id_or_code: 'folder12', selected: false });
            containersActions.setContainerSelected({ id_or_code: 'productive_agricultural_land', selected: false });
        }
    }, [ layerCode ]);

    const [ showFilters, setShowFilters ] = useState(false);
    const filters = useSelector((state: IState) => getContainerFilters(state, layerCode));

    let is_plots_layer = layerCode === 'plots';
    let layer_has_filters = (filters.length > 0 && !is_plots_layer);

    const getOnFilterClick = () => {
        if (layer_has_filters || is_plots_layer) {
            return () => {
                if (is_plots_layer) {
                    /**
                     * Для планшетов без этой логики не будет открываться окно подбора площадок
                     * по кнопке из списка объектов. По логике на плашетах нельзя показать одновременно и окно со списком объектов
                     * и окно подбора площадок поэтому окно подбора площадок скрывается когда показывается окно
                     * со списком объектов. Поэтому перед тем как показать окно подбора площадок нужно закрыть окно со списком объектов.
                     */
                    if (isTablet) {
                        routes.goBack(routes.map, { container: 'root' });
                    }

                    appActions.showObjectFiltersWindow();
                } else {
                    appActions.hideObjectFiltersWindow();
                    setShowFilters(!showFilters);
                }
            };
        } else {
            return false;
        }
    };

    const handleCloseClick = () => {
        if (showFilters) {
            setShowFilters(false);
        } else {
            routes.goBack(routes.map, { container: 'root' });
        }
    };

    return (
        <Panel className="object-list-panel">
            <CloseButton onClick={handleCloseClick} />
            <ObjectsList
                layerCode={layerCode}
                onFilterClick={getOnFilterClick()}
            />
            {filters.length > 0 && (
                <div
                    className={clsx('object-list-filters', {
                        'active': showFilters
                    })}
                >
                    <ListFilters containerCode={layerCode} contFilters={filters} />
                </div>
            )}
        </Panel>
    );
};

export const ListWindow = ListWindowComponent;
